import { ref } from "firebase/database";
import { useObjectVal } from "react-firebase-hooks/database";
import { fbDatabase } from "../firebase";

export type TierFeaturesMap = Record<string, string[]>;

export function useTierFeatures() {
  return useObjectVal<TierFeaturesMap>(ref(fbDatabase, "tierFeatures"));
}
